import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  InputGroup,
  Label,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function PersonalDetails({
  tenantData,
  setSelectedData,
  selectedData,
  addPersonalDetailMutate,
  isPersonalDetailLoading,
}) {
  const [data, setData] = useState(tenantData?.tenant);

  useEffect(() => {
    setData(tenantData?.tenant);
  }, [tenantData]);

  const personalFormik = useFormik({
    initialValues: {
      name: data?.name ?? "",
      mobile: data?.mobile ?? "",
      email: data?.email ?? "",
      gender: data?.gender ? String(data?.gender) : "",
      occupation: data?.occupation ?? "",
      dob: data?.dob ?? "",
      address: data?.address ?? "",
      nationality: data?.nationality ?? "Indian",
      alternateMobile: data?.alternateMobile ?? "",
      monthlyIncome: data?.monthlyIncome ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string(),
      mobile: Yup.string(),
      email: Yup.string(),
      gender: Yup.string(),
      occupation: Yup.string(),
      dob: Yup.date(),
      address: Yup.string(),
      nationality: Yup.string(),
      monthlyIncome: Yup.string(),
    }),
    onSubmit: (values) => {
      if (!values.name) {
        toast.error("Name is required");
        return; 
      }
      if (!values.mobile) {
        toast.error("Mobile Number is required");
        return; 
      }
      if (!/^\d{10}$/.test(values.mobile)) {
        toast.error("Mobile Number must be exactly 10 digits");
        return;
      }
      
      if (!values.gender) {
        toast.error("Gender is required");
        return; 
      }
      if (!values.occupation) {
        toast.error("Occupation is required");
        return; 
      }
      if (!values.dob) {
        toast.error("Date of Birth is required");
        return; 
      }
      if (!values.address) {
        toast.error("Address is required");
        return; 
      }
      if (!values.nationality) {
        toast.error("Nationality is required");
        return; 
      }
      if (!values.monthlyIncome) {
        toast.error("Monthly Income is required");
        return; 
      }
  
      addPersonalDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <>
      <div>
        <Title>Personal Details</Title>
        <form
          onSubmit={personalFormik.handleSubmit}
          className="grid grid-cols-1 gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="name">Tenant Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={personalFormik.values.name}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.name && personalFormik.errors.name && (
                  <p className="text-rose-600 text-sm">
                    {personalFormik.errors.name}
                  </p>
                )} */}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="mobile">Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="mobile"
                  name="mobile"
                  value={personalFormik.values.mobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      personalFormik.setFieldValue("mobile", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.mobile &&
                  personalFormik.errors.mobile && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.mobile}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="email">Email</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="email"
                  name="email"
                  value={personalFormik.values.email}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.email &&
                  personalFormik.errors.email && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.email}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="gender">Gender</Label>
              <FieldWrapper>
                <Select
                  id="gender"
                  name="gender"
                  className="w-full pl-2"
                  value={personalFormik.values.gender}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                >
                  <MenuItem value="1">Male</MenuItem>
                  <MenuItem value="2">Female</MenuItem>
                  <MenuItem value="3">Others</MenuItem>
                </Select>
                {/* {personalFormik.touched.gender &&
                  personalFormik.errors.gender && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.gender}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="occupation">Occupation</Label>
              <FieldWrapper>
                <Select
                  id="occupation"
                  name="occupation"
                  className="w-full pl-2"
                  value={personalFormik.values.occupation} // Match with formik value
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                >
                  <MenuItem value="Student">Student</MenuItem>
                  <MenuItem value="Professional">Professional</MenuItem>
                  <MenuItem value="Self Employed">Self Employed</MenuItem>
                </Select>
                {/* {personalFormik.touched.occupation &&
                  personalFormik.errors.occupation && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.occupation}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="dob">DOB</Label>
              <FieldWrapper className="relative">
                <Input
                  type="date"
                  name="dob"
                  id="dob"
                  className="pl-3"
                  value={personalFormik.values.dob}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.dob && personalFormik.errors.dob && (
                  <p className="text-rose-600 text-sm">
                    {personalFormik.errors.dob}
                  </p>
                )} */}
                {/* <img
                  src={Images.Calender}
                  alt="Calendar icon"
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
                /> */}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <InputGroup>
            <Label htmlFor="address">Address</Label>
            <FieldWrapper>
              <Textarea
                type="text"
                id="address"
                name="address"
                rows={3}
                value={personalFormik.values.address}
                onChange={personalFormik.handleChange}
                onBlur={personalFormik.handleBlur}
              />
              {/* {personalFormik.touched.address &&
                personalFormik.errors.address && (
                  <p className="text-rose-600 text-sm">
                    {personalFormik.errors.address}
                  </p>
                )} */}
            </FieldWrapper>
          </InputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="nationality">Nationality</Label>
              <FieldWrapper>
                <Select
                  id="nationality"
                  name="nationality"
                  className="w-full pl-2"
                  value={personalFormik.values.nationality}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                >
                  <MenuItem value="American">American</MenuItem>
                  <MenuItem value="Canadian">Canadian</MenuItem>
                  <MenuItem value="British">British</MenuItem>
                  <MenuItem value="Australian">Australian</MenuItem>
                  <MenuItem value="Indian">Indian</MenuItem>
                  <MenuItem value="Chinese">Chinese</MenuItem>
                  <MenuItem value="Japanese">Japanese</MenuItem>
                  <MenuItem value="German">German</MenuItem>
                  <MenuItem value="French">French</MenuItem>
                  <MenuItem value="Italian">Italian</MenuItem>
                  <MenuItem value="Russian">Russian</MenuItem>
                  <MenuItem value="Brazilian">Brazilian</MenuItem>
                  <MenuItem value="Mexican">Mexican</MenuItem>
                  <MenuItem value="South African">South African</MenuItem>
                  <MenuItem value="Spanish">Spanish</MenuItem>
                  <MenuItem value="Korean">Korean</MenuItem>
                  <MenuItem value="Argentinian">Argentinian</MenuItem>
                  <MenuItem value="Dutch">Dutch</MenuItem>
                  <MenuItem value="Swedish">Swedish</MenuItem>
                  <MenuItem value="Turkish">Turkish</MenuItem>
                </Select>
                {/* {personalFormik.touched.nationality &&
                  personalFormik.errors.nationality && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.nationality}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="alternateMobile">Alternate Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="alternateMobile"
                  name="alternateMobile"
                  value={personalFormik.values.alternateMobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      personalFormik.setFieldValue("alternateMobile", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.alternateMobile &&
                  personalFormik.errors.alternateMobile && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.alternateMobile}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="monthlyIncome">Monthly Income (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="monthlyIncome"
                  name="monthlyIncome"
                  value={personalFormik.values.monthlyIncome}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      personalFormik.setFieldValue("monthlyIncome", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
                {/* {personalFormik.touched.monthlyIncome &&
                  personalFormik.errors.monthlyIncome && (
                    <p className="text-rose-600 text-sm">
                      {personalFormik.errors.monthlyIncome}
                    </p>
                  )} */}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={isPersonalDetailLoading}>
              {isPersonalDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>
    </>
  );
}

const FieldWrapper = tw.div`w-full`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const SubmitBtn = tw.button`text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y  break-words overflow-hidden`;
